module.exports = __webpack_public_path__ + "img/ico_tab2_addaccount@3x.48d987b2.png";